<template>
  <div class="w-full h-full">
    <el-input
      placeholder="请输入关键词"
      v-model="metalBimChildKeyword"
      size="small"
      clearable
      @keypress.enter.native="searchData()"
      class="icon-search__input mb-10px"
    >
      <i
        slot="append"
        class="el-icon-search cursor-pointer icon-search__input"
        @click="searchData()"
      ></i>
    </el-input>
    <el-table
      :data="tableData"
      highlight-current-row
      class="!h-[calc(100%-84px)] !w-full"
      ref="tableRef"
      v-loading="tableLoading"
    >
      <el-table-column label="" width="15">
        <template>
          <div class="selected-row"></div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        :label="item.label"
        :width="item.width"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div
            v-if="item.type === 'ThreeDimensional'"
            @click="moveThreeD(scope.row)"
            class="cursor-pointer text-hex-00bcc8 truncate"
          >
            {{ scope.row[item.prop] }}
          </div>
          <div v-else class="truncate">
            {{ scope.row[item.prop] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{ row }">
          <div @click="lookDetail(row)" class="cursor-pointer text-hex-00bcc8">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @size-change="getTableData()"
      @current-change="getTableData()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :pager-count="5"
      layout="prev, pager, next"
      :total="page.total"
      class="text-center"
    ></el-pagination>
  </div>
</template>

<script>
// api
import { MetalBIMApi } from '@wiz-api/huizhou2'

// metal default data
import { metalBimChildConfig } from './config'
import { isJSONObj } from '../../../assets/js/scene/scene'

const metalbimapi = new MetalBIMApi()

export default {
  data() {
    return {
      tableData: [],
      tableLoading: true,
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      metalBimChildKeyword: '',
      metalBimBaseData: {},
    }
  },
  methods: {
    // 获取场景aabb
    async getSceneAabb(nodes) {
      const aabbList = []
      for (let i = 0; i < nodes.length; i += 1) {
        const item = nodes[i]
        // eslint-disable-next-line no-await-in-loop
        const aabb = await this.cloudRender.NodeProxy.getAabb(item)
        if (aabb) {
          aabbList.push(aabb.data.aabb)
        }
      }
      const maxX = _.maxBy(aabbList, (item) => {
        return item[1][0]
      })
      const maxY = _.maxBy(aabbList, (item) => {
        return item[1][1]
      })
      const maxZ = _.maxBy(aabbList, (item) => {
        return item[1][2]
      })
      const minX = _.minBy(aabbList, (item) => {
        return item[0][0]
      })
      const minY = _.minBy(aabbList, (item) => {
        return item[0][1]
      })
      const minZ = _.minBy(aabbList, (item) => {
        return item[0][2]
      })
      return {
        max: [maxX[1][0], maxY[1][1], maxZ[1][2]],
        min: [minX[0][0], minY[0][1], minZ[0][2]],
      }
    },
    async moveThreeD(row) {
      const metalModels = row.metalModels
      if (metalModels && !_.isEmpty(metalModels)) {
        const allInfoArr = []
        await this.getAllInfo(0, metalModels, allInfoArr)
        if (_.isEmpty(allInfoArr)) {
          return
        }
        const allInfoArrItems = allInfoArr.map((it) => {
          return it.getDataInfo().item
        })
        this.cloudRender.NodeProxy.player.Native.ModelTree.setSelectItems(allInfoArrItems)
        const modelAabb = await this.getSceneAabb(allInfoArr)
        const mat = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
        await this.cloudRender.Camera.player.Native.Camera.addMoveToAabb(modelAabb, mat, 0, 1, 2)
      } else {
        await this.cloudRender.NodeProxy.removeSelectedItem() // 取消选中
        if (this.customProps.sceneOptions && isJSONObj(this.customProps.sceneOptions.jsonData)) {
          const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
          const cameraParams = isJSONObj(jsonData.cameraParams)
            ? JSON.parse(jsonData.cameraParams)
            : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
          const { eye, target, up } = cameraParams
          await this.cloudRender.Camera.moveCamera('CameraParam', { eye, target, up }) // 回到初始位置
        } else if (this.customProps.sceneOptions.isEnableGis) {
          await this.cloudRender.Camera.moveCamera('LLH', [
            this.customProps.sceneOptions.longitude,
            this.customProps.sceneOptions.latitude,
            50,
          ])
        } else {
          await this.cloudRender.Camera.moveCamera('CameraParam', {
            eye: [-1028, 580, 13821],
            target: [-1028, 579, 85],
            up: [0, 1, 0],
          })
        }
      }
    },
    async getAllInfo(index, data, tempArr) {
      if (index < data.length) {
        const result = await this.cloudRender.NodeProxy.getInfo('Code', data[index].modelId)
        if (result.status) {
          tempArr.push(result.data)
          // 设置节点颜色
          // await this.cloudRender.Camera.player.Native.ModelTree.setItemColor(
          //   result.data.getDataInfo().item,
          //   0x00ff6699
          // )
        }
        await this.getAllInfo(index + 1, data, tempArr)
      }
    },
    lookDetail(row) {
      this.$emit('transferEvent', {
        toCom: { code: 'MetalBim', origin: '', name: '金属BIM' },
        type: 'mainComponent',
        props: {
          ...this.metalBimBaseData,
          ...row,
        },
      })
    },
    async getTableData() {
      this.tableLoading = true
      const [err, data] = await metalbimapi[this.searchApi](this.page.pageNo, this.page.pageSize, {
        ledgerBaseId: this.ledgerBaseId,
        keyWord: this.metalBimChildKeyword,
        metalType: '管道二级台账',
      })
      if (!err && data) {
        this.tableData = _.map(data.items, (item) => {
          return {
            ...item,
            PrGroupType: this.transferProps.prGroupType,
            PrName: this.transferProps.prName,
            prCode: item.prCode,
            prName: item.prName,
          }
        })
        this.page.total = data.totalCount
        this.tableLoading = false
      }
    },
    async searchData() {
      this.page.pageNo = 1
      await this.getTableData()
    },
  },
  computed: {
    tableColumns() {
      return metalBimChildConfig[this.transferProps.type].tableHead
    },
    searchApi() {
      return metalBimChildConfig[this.transferProps.type].api
    },
    ledgerBaseId() {
      return this.transferProps.prId
    },
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {},
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    customProps: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    transferProps: {
      handler(data) {
        if (data.prId) {
          this.metalBimBaseData = { ...data, fatherPrCode: data.prCode, fatherPrName: data.prName }
          this.page.pageNo = 1
          this.getTableData()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}
::v-deep .el-pagination.is-background.el-pagination--small .el-pager li {
  min-width: 24px;
  margin: 0 5px;
  padding: 0 4px;
}
</style>
